module.exports = __webpack_public_path__ + "96ac2f694b4d8767aa241b4b9d8727b7.mp3";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/level_6_rustig.mp3
// module id = 79
// module chunks = 0